
// import { Toolbar } from "ngx-editor";
export class DataConstants {

}
export const REGEX_PATTERNS = {
	alphabetsOnly: '^[a-zA-Z]+( [a-zA-Z]+)*$',
	alphaNumeric: '^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$',
	alphaNumericWithSpaceDotAndSlash: '^[a-zA-Z0-9]+[a-zA-Z0-9 \\/.\'\\-\\(\\)]*$',
	alphaNumericWithSpaceDotAndSlashAndComma: '^[a-zA-Z0-9]+[a-zA-Z0-9 \\/.\'\\-\\(\\)\\,]*$',
	numberGreaterThanZero: '^(0*[1-9][0-9]*)$',
	number: '^[0-9]+$',
	address: /^(?![\s\t])[a-zA-Z0-9\s.,'-\\/]+(?<![\s\t])$/,
	email: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$',
	mobileNoTwelveDigit: /^\d{10,12}$/,
	mobileNoTenDigit: /^\d{10}$/,
	imei: /^\d{15}$/
}


// export const TOOLBAR_ITEMS: Toolbar = [
// 	["bold", "italic"],
// 	["underline", "strike"],
// 	["code", "blockquote"],
// 	["ordered_list", "bullet_list"],
// 	[{ heading: ["h1", "h2", "h3", "h4", "h5", "h6"] }],
// 	["text_color", "background_color"],
// 	["align_left", "align_center", "align_right", "align_justify"]
// ];
